import { useState } from "react";

import { AlertV4, ButtonV4, ModalV4 } from "../common/ui";
import type { CheckoutInfo } from "./checkoutModelV4";

// Types
type ModalCancelCheckoutV4Props = {
  info: CheckoutInfo;
  saving?: boolean;
  error?: unknown;
  onConfirm: () => void;
  onClose: () => void;
};

const ModalCancelCheckoutV4 = (props: ModalCancelCheckoutV4Props) => {
  const [sent, setSent] = useState(false);

  // Handler
  const handleConfirm = () => {
    setSent(true);
    props.onConfirm();
  };

  // Render
  return (
    <ModalV4 title="ยกเลิก Check out" width={520} tone="danger" onClose={props.onClose}>
      <div className="hv4-co-body">
        <div className="hv4-co-undo-text">
          Check out แบบ <b>{props.info.typeText}</b>
          <br />
          <span>{props.info.atText}</span>
        </div>
        <div className="hv4-co-undo-warn">
          หลังยกเลิก สถานะจะกลับเป็น "กำลังพบแพทย์" และกด Check out ใหม่ได้
        </div>
        <AlertV4 tone="danger" error={sent ? props.error : null} />
        <div className="hv4-co-foot">
          <ButtonV4 variant="ghost" onClick={props.onClose}>
            ปิด
          </ButtonV4>
          <ButtonV4 variant="danger" disabled={props.saving} onClick={handleConfirm}>
            ยืนยันยกเลิก Check out
          </ButtonV4>
        </div>
      </div>
    </ModalV4>
  );
};

ModalCancelCheckoutV4.displayName = "ModalCancelCheckoutV4";

export default ModalCancelCheckoutV4;
